import styled from 'styled-components';

import { Color } from '../../constants/Colors';

export const HorizontalLine = styled.span`
  border-top: 1px solid ${Color.MYSTIC};
  display: block;
  margin: 0 auto;
`;
